
import { defineComponent, PropType, reactive } from "vue";
export default defineComponent({
   props: {
      height: {
         type: [String],
         default: "560px",
      },
   },
   setup() {
      return {};
   },
   /****************************************************************
    *
    *
    *
    ***************************************************************/
});
